import React from 'react';

import { PagePlaceholder } from '../../../components/page-placeholder/page-placeholder';

import styles from './character-list-placeholder.module.scss';
interface Props {
  onAddCharacterClicked: () => void;
}

export const CharacterListPlaceholder: React.FC<Props> = ({ onAddCharacterClicked }) => (
  <div className={styles['container']}>
    <PagePlaceholder
      backgroundImgUrl="/images/Process_Badges_Pre_Production.svg"
      description='Characters will be displayed here, you can add them by clicking on the "Create
              character" button'
      actionButton={{ text: 'Create character', onClick: onAddCharacterClicked }}
    />
  </div>
);
